import { Controller, Toolbar } from '@tencent/workbench';
import { ClearFeature } from './clear-feature';
import { TOOLBAR_ITEMS, config } from './config';

/**
 * 清除格式
 */
@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class ClearController {
    constructor(private readonly feature: ClearFeature) {
    }

    @Toolbar(config.id, 'onClick')
    public onClick() {
        this.feature.onClick();
    }
}
